import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
} from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import {
  COVERAGE_TYPES_FIELD,
  SPLIT_GROUP_FIELD,
  coverageObjektSparten,
  objektSpartenOfType,
} from "../FormDefinitionRenderer/coverageSelection.js";
import {
  useFormCoverage,
  useFormEditMode,
} from "../FormDefinitionRenderer/contexts.js";

/**
 * "Was ist passiert?": one yes/no question per coverage type the Objekt has,
 * labelled with the Objektsparten it stands for.
 * Ticking adds the id of the first Objektsparte (by name) of that coverage
 * type to `_coverage_types`, unticking removes the coverage type's Sparten.
 */
export default function CoverageTypeQuestionsControl({ item }) {
  const { setValue } = useFormContext();
  const { enabled, coverageTypes, objektSparten } = useFormCoverage();
  const editMode = useFormEditMode();
  const selected = useWatch({ name: COVERAGE_TYPES_FIELD }) ?? [];
  const split_group = useWatch({ name: SPLIT_GROUP_FIELD });

  const coverage_objekt_sparten = coverageObjektSparten(
    coverageTypes,
    objektSparten
  );
  // A sibling's Sparte is fixed after a split; a single Objektsparte needs no
  // question.
  if (!enabled || split_group || coverage_objekt_sparten.length <= 1) {
    return null;
  }

  const toggle = (key, checked) => {
    const of_type = objektSpartenOfType(objektSparten, key).map(
      (sparte) => sparte.sparte_id
    );
    const rest = selected.filter((id) => !of_type.includes(id));
    setValue(COVERAGE_TYPES_FIELD, checked ? [...rest, of_type[0]] : rest, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const questions = coverageTypes.filter(
    (type) => objektSpartenOfType(objektSparten, type.key).length > 0
  );

  return (
    <FormControl component="fieldset" error={selected.length === 0}>
      <FormLabel component="legend">
        {item.label ?? "Was ist passiert?"}
      </FormLabel>
      {questions.map((type) => {
        const of_type = objektSpartenOfType(objektSparten, type.key);
        return (
          <FormControlLabel
            key={type.key}
            label={`${of_type.map((sparte) => sparte.sparte).join(" / ")} (${type.question})`}
            control={
              <Checkbox
                checked={selected.some((id) =>
                  of_type.some((sparte) => sparte.sparte_id === id)
                )}
                disabled={!editMode}
                onChange={(event) => toggle(type.key, event.target.checked)}
              />
            }
          />
        );
      })}
      {selected.length === 0 && (
        <FormHelperText>
          Bitte mindestens eine Situation auswählen
        </FormHelperText>
      )}
    </FormControl>
  );
}
